/**
 * @param {String} x
 * @return {String}
 */
export const padTo30 = (x) => {
  const message = [...'                              ']
  for (let i = 0; i < x.length; ++i) {
    message[i] = x.charAt(i)
  }
  return message.join('')
}
